import{a as e}from"./chunk-W5EWQAXN.js";import{n as o,o as r}from"./chunk-2O3P3S23.js";var f=new o({locale:[e,r]});export{f as a};
